<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <VLayout class="rounded-md flex-column">
            <Menubar ref='menubar'
                     class="px-2 menu-horizontal-outer bg-white shadow-sm"
                     :model="menuItems">
                <template #start>
                    <v-col>
                        <Image :src="menuLogo"
                               style="height:32px" />
                    </v-col>
                </template>

                <template #item="{ item, props, hasSubmenu, root }">
                    <span v-if="(!item?.hidden || isCreator) && (Object.values(unprotectedMenuItems).includes(item?.fullPath?.toLowerCase().replace(/[_\s]/g, '-')) || hasPermission(item?.fullPath))">
                        <Link v-ripple
                              v-if="item.route"
                              :href="checkRoute(item.route, null, item.label)"
                              :id="item.id"
                              :style="item.itemstyle"
                              class="flex flex-row flex-nowrap menu-horizontal-inner"
                              style="white-space: nowrap; overflow: visible; min-width: max-content;"
                              v-bind="props.action">
                        <div inert>
                            <span :class="item.icon"
                                  :style="item.iconstyle" />
                            <span class="ml-2"
                                  :class="item.labelclass"
                                  :style="item.labelstyle">{{ __(item.label) }}</span>
                            <div v-if="item.description"
                                 class="menu-horizontal-description">
                                <span v-html="item.description"></span>
                            </div>
                        </div>
                        </Link>

                        <div v-ripple
                             v-else
                             class="flex flex-row flex-nowrap menu-horizontal-inner"
                             style="white-space: nowrap; overflow: visible; min-width: max-content;"
                             :style="item.itemstyle"
                             v-bind="props.action">
                            <div class="align-items-start cursor-pointer w-100">
                                <span :class="item.icon"
                                      :style="item.iconstyle" />
                                <span class="ml-2"
                                      :class="item.labelclass"
                                      :style="item.labelstyle">{{ __(item.label) }}</span>
                                <i v-if="hasSubmenu"
                                   :class="['pi pi-angle-down text-primary', { 'pi-angle-down ml-2': root, 'pi-angle-right ml-2': !root }]"
                                   :style="item.submenustyle"
                                   style="float:right; vertical-align: middle;"></i>
                                <div v-if="item.description"
                                     class="menu-horizontal-description"
                                     :id="item.id">
                                    <span v-html="item.description"></span>
                                </div>
                            </div>
                        </div>
                    </span>
                </template>

                <template #end>
                    <div class="flex align-items-center">
                        <div class="flex menu-horizontal-left-part">
                            <div class="menu-horizontal-left-part-begin"></div>
                            <div class="menu-horizontal-left-part-middle"></div>
                            <div class="menu-horizontal-left-part-end">
                                <Button v-if="multiModuleApp"
                                        icon="pi pi-server"
                                        severity="info"
                                        text
                                        size="large"
                                        v-tooltip.top="__('Select module')"
                                        @click="selectModule" />
                            </div>
                        </div>
                        <div class="session-time-header"
                             style="margin-left:20px"></div>
                    </div>

                    <div class="flex items-center space-x-4">
                        <div class="relative"
                             ref="userDropdownRef">
                            <button @click="showUserDropdown = !showUserDropdown"
                                    class="flex flex-row flex-nowrap menu-horizontal-inner p-menubar-item-link items-center rounded transition text-gray-800 font-medium focus:outline-none"
                                    style="white-space: nowrap; overflow: visible; min-width: max-content;">
                                <span class="menu-item">{{ userName }}</span>
                                <i class="pi pi-angle-down text-gray-800 ml-2"></i>
                            </button>
                            <div v-if="showUserDropdown"
                                 class="absolute right-0 mt-2 bg-white rounded shadow-lg border border-gray-200 z-50 p-1">
                                <Link :href="checkRoute('user-profile', { user_id: userId })"
                                      class="flex flex-row flex-nowrap menu-horizontal-inner p-menubar-item-link text-gray-800 hover:bg-gray-100 items-center"
                                      style="white-space: nowrap; overflow: visible; min-width: max-content;">
                                <span class="pi pi-user mr-2"></span>
                                <span class="menu-item">Profil użytkownika</span>
                                </Link>
                                <button @click="saveSession"
                                        class="flex flex-row flex-nowrap menu-horizontal-inner p-menubar-item-link w-full text-gray-800 hover:bg-gray-100 items-center"
                                        style="white-space: nowrap; overflow: visible; min-width: max-content;">
                                    <span class="pi pi-save mr-2"></span>
                                    <span class="menu-item">Zapisz sesję</span>
                                </button>
                                <button @click="removeSession"
                                        class="flex flex-row flex-nowrap menu-horizontal-inner p-menubar-item-link w-full text-gray-800 hover:bg-gray-100 items-center"
                                        style="white-space: nowrap; overflow: visible; min-width: max-content;">
                                    <span class="pi pi-trash mr-2"></span>
                                    <span class="menu-item">Usuń sesję</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </template>
            </Menubar>

            <VFooter app
                     style="padding:0; margin:0; background-color:transparent; box-shadow:none; border:none;">
                <footer class="w-full flex items-center justify-between bg-gray-50 border-t border-gray-200 py-3 px-6 text-sm">
                    <div class="flex items-center space-x-4">
                        <Image :src="developerLogo"
                               class="h-8 w-auto" />
                        <div>
                            <span class="text-gray-500 font-light">Powered by © 4Evolve wersja 1.0<br>rewizja {{ systemRevision }}</span>
                        </div>
                    </div>
                    <nav class="flex items-center space-x-4">
                        <Link :href="checkRoute('dashboard-help', null, null)"
                              class="text-gray-500 hover:text-blue-600 transition">Pomoc</Link>
                        <Link :href="checkRoute('dashboard-changelog', null, null)"
                              class="text-gray-500 hover:text-blue-600 transition">Changelog</Link>
                        <Link :href="checkRoute('dashboard-privacy', null, null)"
                              class="text-gray-500 hover:text-blue-600 transition">Polityka prywatności</Link>
                    </nav>
                </footer>
            </VFooter>

        </VLayout>

        <div class="layout-box"
             style="margin-bottom:70px">
            <slot></slot>
        </div>
        <flash-message />
    </div>
</template>

<script setup>
import Menubar from 'primevue/menubar';
import Button from 'primevue/button';
import { Link, router, usePage } from '@inertiajs/vue3'
import { ref, onMounted, onBeforeMount, watchEffect, onBeforeUnmount } from "vue";
import Image from '@helper/Image.vue'
import { initFunctions } from "../../init.js";
import { __, saveAppSession, removeAppSession, hasPermission, can, checkRoute, getStoreValue, setStoreValue, getServerValue } from '@pages/Helper/utils.js';
import { menuLogo, developerLogo } from '@helper/constants.js'

const menuItems = ref(null);
const unprotectedMenuItems = ref({});
const userName = ref(null);
const userId = ref(null);
const multiModuleApp = ref(false);
const systemRevision = ref(getStoreValue('systemRevision'));

const dataFromSession = ref(null);
const currentDate = ref(null)
const page = usePage();
const isLoading = ref(false);
const isCreator = ref(false);
const showUserDropdown = ref(false);
const userMenu = ref(null)
const userMenuItems = [
    {
        label: 'Profil użytkownika',
        icon: 'pi pi-user',
        command: () => { }
    },
    {
        label: 'Zapisz sesję',
        icon: 'pi pi-save',
        command: () => { saveSession() }
    },
    {
        label: 'Usuń sesję',
        icon: 'pi pi-trash',
        command: () => { removeSession() }
    }
]

//------------------------------------------------------------------------------

watchEffect(async () => {
    let savedDataFromSession = null
    savedDataFromSession = getStoreValue('dataFromSession')
    if (!savedDataFromSession) {
        savedDataFromSession = await getServerValue('dataFromSession')
        if (savedDataFromSession?.hasOwnProperty('dataFromSession')) {
            setStoreValue('dataFromSession', savedDataFromSession.dataFromSession)
            savedDataFromSession = savedDataFromSession.dataFromSession
        }
    }

    if (savedDataFromSession) {
        dataFromSession.value = savedDataFromSession
    }
});

// ------------------------------------------------------------------------------

watchEffect(async () => {
    currentDate.value = page.props.currentDate;
});

// ------------------------------------------------------------------------------

onBeforeMount(async () => {
    const layoutMenu = page.props.menuContent;

    if (layoutMenu && layoutMenu.menu) {
        menuItems.value = layoutMenu.menu;
        unprotectedMenuItems.value = layoutMenu.unprotected;
        userName.value = layoutMenu.userName;
        userId.value = layoutMenu.userId;
        multiModuleApp.value = layoutMenu.multiModuleApp;

        if (menuItems.value.length == 0) {
            console.error('Wybrany moduł (' + layoutMenu.moduleSymbol + ') nie posiada pliku json z zawartością menu. Nastąpi przekierowanie do strony wyboru modułu')
        }
    }

    clearInterval(window.displaySessionInterval);
})

//------------------------------------------------------------------------------

onMounted(async () => {
    window.endOfSession = false
    window.showDisplaySessionTime = false;
    window.lastActivityTime = null;
    isLoading.value = true;
    await initFunctions();
    isLoading.value = false;
    isCreator.value = getStoreValue('isCreator')

    const elements = document.querySelectorAll('[aria-hidden]');
    elements.forEach(element => {
        //element.setAttribute('aria-hidden', 'false');
        element.removeAttribute('aria-hidden');
    });
})

//------------------------------------------------------------------------------

const saveSession = () => {
    saveAppSession();
}

//------------------------------------------------------------------------------

const removeSession = () => {
    removeAppSession();
}

//------------------------------------------------------------------------------

const selectModule = () => {
    router.get(route('select-module', { module: getStoreValue('currentModule') }))
}

//------------------------------------------------------------------------------

const userDropdownRef = ref(null);

const handleClickOutside = (event) => {
    if (userDropdownRef.value && !userDropdownRef.value.contains(event.target)) {
        showUserDropdown.value = false;
    }
};

onMounted(() => {
    document.addEventListener("mousedown", handleClickOutside);
});
onBeforeUnmount(() => {
    document.removeEventListener("mousedown", handleClickOutside);
});
</script>

<style scoped>
.v-layout {
    position: sticky;
    z-index: 2;
    top: 0;
}

:deep(.p-menubar-start) {
    padding: 0 40px 0 20px;
    display: flex;
}

:deep(.p-menubar-end) {
    position: absolute;
    padding: 0 40px 0 20px;
    right: 0;
}


:deep(.p-menubar) {
    background-color: var(--primary-color);
    color: var(--text-color);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

:deep(.p-menuitem-link) {
    align-items: flex-start;
    min-height: 50px;
    /* Zwiększenie wysokości opcji menu */
    padding: 12px 16px;
    /* Zwiększenie paddingu dla lepszego wyglądu */
}

:deep(.p-menuitem-content) {
    min-height: 50px;
    /* Wysokość dla zawartości opcji menu */
    display: flex;
    align-items: center;
    /* Wyśrodkowanie w pionie */
}

:deep(.p-submenu-list) {
    padding: 0px;
    box-shadow: 0px 9px 15px -1px rgba(66, 68, 90, 1);
    -webkit-box-shadow: 0px 9px 15px -1px rgba(66, 68, 90, 1);
    -moz-box-shadow: 0px 9px 15px -1px rgba(66, 68, 90, 1);
}

:deep(.p-submenu-list .p-menuitem-link) {
    min-height: 45px;
    /* Nieco mniejsza wysokość dla podmenu */
    padding: 10px 16px;
}

.admin-area-in-footer {
    color: red;
    background-color: yellow;
    margin: 0 5px;
    font-weight: normal;
    font-size: 10px;
}
</style>
